import { authHeader } from '../../_helpers';
import axios from 'axios';

export const SuperAdminService = {
    getOrgDetailsHandler,
    editOrgDetailsHandler,
    deleteOrgDetailsHandler,

    getAssessmentOrganisationHandler,
    getAnalyticsOrganisationHandler,
    addAssessmentOrganisationHandler,
    removeAssessmentOrganisationHandler,

    getAnalyticsOrgBatchesHandler,
    addAnalyticsActiveBatchesHandler,
    getAnalyticsActiveBatchesHandler,
    removeAnalyticsActiveBatchesHandler,

    getOrgAdminsHandler,
    addOrgAdminHandler,
    makeOrgPrimaryAdminHandler,
    removeOrgAdminHandler,

    getCreditsHandler,
    addCreditsHandler,
    revokeCreditsHandler,

    getMetricsListHandler,
    getAnalyticsMetricListHandler,
    changeMetricAccessHandler,
    editMetricHandler,
    deleteMetricHandler,

    assignMetricHandler,
    editAssignMetricHandler,
    deleteAssignMetricHandler,

    getSwotTextHandler,
    editSwotTextHandler,

    getFocusAreaTextHandler,
    editFocusAreaTextHandler,

    getReviewQuestionsHandler,
    editReviewQuestionsHandler,


    //assign assessor groups to org
    removeAssessorGroup,
    getAssessment_groupsList,
    postAssessment_groupsList,
    assessor_groupList,
    

    // Assign Metric and Define Levels
    dropdownListAssignMetric,
    addNewCompetency,
    editExistingCompetency,
    deleteExistingCompetency,


    defaultMetricListApi,
    combinedMetricListApi,
    combinedAllowAccessApi,
    combinedDenyAccessApi
};



axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function combinedDenyAccessApi(data) {
    return axios.post(`/analytics/metrics/deny/access/?access_token=${token}`, data)
    .then(response => {
        return response;
    });
}

function combinedAllowAccessApi(data) {
    return axios.post(`/analytics/metrics/allow/access/?access_token=${token}`, data)
    .then(response => {
        return response;
    });
}

function combinedMetricListApi(data) {
    return axios.post(`/analytics/metrics/list/?access_token=${token}`, data)
    .then(response => {
        return response;
    });
}

function defaultMetricListApi(data) {
    return axios.post(`/analytics/default/and/organisation/competency/metric/list/?access_token=${token}`, data)
    .then(response => {
        return response;
    });
}

function deleteExistingCompetency(data) {
    return axios.post(`/analytics/default/assessment/metrics/delete/?access_token=${token}`, data)
    .then(response => {
        return response;
    });   
}

function editExistingCompetency(data) {
    return axios.post(`/analytics/organisation/levels/edit/?access_token=${token}`, data)
    .then(response => {
        return response;
    });   
}

function addNewCompetency(data) {
    return axios.post(`/analytics/organisation/add/level/?access_token=${token}`, data)
    .then(response => {
        return response;
    });   
}

function dropdownListAssignMetric(data) {
    return axios.post(`/analytics/default/assessment/metric/list/?access_token=${token}`, data)
    .then(response => {
        return response;
    });   
}

function assessor_groupList(data) {
    return axios.post(`/analytics/organsiation/assessment_assessor_groups/?access_token=${token}`, data)
    .then(response => {
        return response;
    });   
}

function postAssessment_groupsList(data) {
    return axios.post(`/analytics/organisation/assessment_groups/list/create/${data.orgId}/?access_token=${token}`, data.data)
    .then(response => {
        return response;
    });   
}


function getAssessment_groupsList(data) {
    return axios.get(`/analytics/organisation/assessment_groups/list/create/${data}/?access_token=${token}`)
    .then(response => {
        return response;
    });   
}

function removeAssessorGroup(data) {
    return axios.post(`/analytics/organisation/assessment_groups/delete/${data.data.orgId}/?access_token=${token}`, data.data.organisation_assessor_id)
    .then(response => {
        return response;
    });   
}


function getOrgDetailsHandler(id) {
    // console.log("access_token",token)
    return axios.get(`/analytics/organisation/view/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function editOrgDetailsHandler(id, fd) {
    // console.log("sdvsdvsdvsvd", id, '  ', fd)
    return axios.patch(`/analytics/organisation/update/${id}/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function deleteOrgDetailsHandler(fd) {
    return axios.post(`/analytics/organisation/delete/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getAssessmentOrganisationHandler(id) {
    return axios.get(`/analytics/assessment/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}
function getAnalyticsOrganisationHandler() {
    return axios.get(`/users/organisation/create/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function addAssessmentOrganisationHandler(fd) {
    return axios.post(`/analytics/assessment/create/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function removeAssessmentOrganisationHandler(fd) {
    return axios.post(`/analytics/assessment/delete/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getAnalyticsOrgBatchesHandler(fd) {
    const data = {
        "analytics_organisation_id": fd
    }
    return axios.post(`/analytics/active_batches/org_batches/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function addAnalyticsActiveBatchesHandler(fd) {
    return axios.post(`/analytics/active_batches/create/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getAnalyticsActiveBatchesHandler(fd) {
    const data = {
        "analytics_organisation_id": fd
    }
    return axios.post(`/analytics/active_batches/list/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function removeAnalyticsActiveBatchesHandler(fd) {
    return axios.post(`/analytics/active_batches/delete/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getOrgAdminsHandler(orgId) {
    return axios.get(`/analytics/org_admin/list/${orgId}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function addOrgAdminHandler(fd) {
    return axios.post(`/analytics/org_admin/create/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function makeOrgPrimaryAdminHandler(fd) {
    return axios.post(`/analytics/org_admin/make_primary/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function removeOrgAdminHandler(fd) {
    return axios.post(`/analytics/org_admin/delete/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getCreditsHandler(data) {
    const fd = {
        'organisation_id': data
    }
    return axios.post(`/analytics/organisation/credits/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function addCreditsHandler(data) {
    return axios.post(`/analytics/organisation/update/add/credits/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function revokeCreditsHandler(data) {
    return axios.post(`/analytics/organisation/update/remove/credits/?access_token=${token}`, data)
        .then(response => {
            return response;
        });
}

function getMetricsListHandler() {
    return axios.get(`/users/default/competency/metric/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getAnalyticsMetricListHandler(fd, type) {
    return axios.post(type ? `/analytics/metrics/list/?access_token=${token}` : `/analytics/organisaton/levels/list/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function changeMetricAccessHandler(fd, type) {
    if (type === 'Add') {
        return axios.post(`/analytics/metrics/add/?access_token=${token}`, fd)
            .then(response => {
                return response;
            });
    }
    if (type === "Remove") {
        return axios.post(`/analytics/metrics/delete/?access_token=${token}`, fd)
            .then(response => {
                return response;
            });
    }
}

function editMetricHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}

function deleteMetricHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}

function assignMetricHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}

function editAssignMetricHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}

function deleteAssignMetricHandler() {
    // return axios.get(`/assessments/allotment/summary/?access_token=${token}`)
    //     .then(response => {
    //         return response;
    //     });
}

function getSwotTextHandler(id) {
    return axios.get(`/analytics/swot/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function editSwotTextHandler(id, fd) {
    return axios.patch(`/analytics/swot/update/${id}/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getFocusAreaTextHandler() {
    return axios.get(`/analytics/focus/create/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function editFocusAreaTextHandler(id, fd) {
    return axios.patch(`/analytics/focus/update/${id}/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}

function getReviewQuestionsHandler(id) {
    return axios.get(`/analytics/review_question/list/${id}/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function editReviewQuestionsHandler(id, fd) {
    return axios.patch(`/analytics/review_question/update/${id}/?access_token=${token}`, fd)
        .then(response => {
            return response;
        });
}


// WEBPACK FOOTER //
// ./src/_services/SuperAdmin/SuperAdmin.service.js